import { useEffect } from "react";
import ApplicationOutcomeComponent from "../../components/applicationComponents/applicationOutcome/applicationOutcomeComponent";
import { useApplicationContext } from "../../components/applicationComponents/context/applicationContext";

export default function ApplicationOutcomePage() {
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "Application Outcome",
      icon: "view-app-icon icon-spec mr-3 mt-0",
    });
  }, []);

  return (
    <>
      <ApplicationOutcomeComponent disabled={false} />
    </>
  );
}
